import type { ContratoDto, MaquinarioDto, ManutencaoDto, RegistroHorimetroDto } from "@/services/locacoes";

/** Tipos de máquina pesada — operador só vê estes equipamentos. */
export const MAQUINA_TIPOS_PESADAS = new Set([
  "Escavadeira",
  "Retroescavadeira",
  "Motoniveladora",
  "Pá Carregadeira",
  "Rolo Compactador",
  "Caminhão Basculante",
  "Caminhão Pipa",
  "Munck",
  "Trator",
]);

export function filterMaquinasPesadas(maquinarios: MaquinarioDto[]): MaquinarioDto[] {
  return maquinarios.filter((m) => MAQUINA_TIPOS_PESADAS.has(m.tipo));
}

export function findContratoAtivoParaMaquina(
  contratos: ContratoDto[],
  maquinaId: string,
): ContratoDto | undefined {
  return contratos.find((c) => c.status === "ativo" && c.maquinaIds.includes(maquinaId));
}

export function minhasSolicitacoesHorimetro(
  registros: RegistroHorimetroDto[],
  userId: string,
): RegistroHorimetroDto[] {
  return registros
    .filter((r) => r.usuarioId === userId && r.origemOperador)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

export function minhasSolicitacoesManutencao(
  manutencoes: ManutencaoDto[],
  userId: string,
): ManutencaoDto[] {
  return manutencoes
    .filter((m) => m.responsavelId === userId && m.origemOperador)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}
